import { render } from "./system-sync-health-modal.vue?vue&type=template&id=4e83316a&scoped=true"
import script from "./system-sync-health-modal.vue?vue&type=script&lang=js"
export * from "./system-sync-health-modal.vue?vue&type=script&lang=js"

import "./system-sync-health-modal.vue?vue&type=style&index=0&id=4e83316a&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e83316a"]])

export default __exports__